import * as PIXI from "pixi.js";
import * as React from "react";
import { SongManager } from "../../Model/SongManagement/SongManager";
import { navigationView } from "../Shared/NavigationView";
import { UIColors } from "../Settings/UITheme";
import { TimelineView } from "../Timeline/TimelineView";
import { EditPanel } from "./EditPanel";
import { PlaybackPanel } from "./PlaybackPanel";
import { EffectsChainPanel } from "./EffectsChainPanel";
import { SerialisePanel } from "./SerialisePanel";
export class SequencerApp extends React.Component {
    constructor(props) {
        super(props);
        this._hideShowCallback = () => { this._timelineRef.current.resizePIXIApp(); };
        this.state = {
            songManager: new SongManager(),
        };
        this._timelineRef = React.createRef();
    }
    componentDidMount() {
        this.props.hideLoader();
    }
    componentWillUnmount() {
        this.state.songManager.destroy();
    }
    render() {
        return React.createElement("div", { className: "fullScreen" },
            React.createElement("div", { style: { position: "relative", width: "100%", height: "100%" } },
                React.createElement("div", { className: "sequencerAppTopBar" },
                    React.createElement(PlaybackPanel, { songManager: this.state.songManager }),
                    React.createElement(EditPanel, null),
                    React.createElement(SerialisePanel, { songManager: this.state.songManager })),
                React.createElement("div", { className: "sequencerAppMainPanel" },
                    React.createElement(PIXITimeline, { ref: this._timelineRef, className: "sequencerAppMainPanelLeft", songManager: this.state.songManager }),
                    React.createElement(EffectsChainPanel, { connectionManager: this.state.songManager.connectionManager, hideShowCallback: this._hideShowCallback }))));
    }
}
export class PIXITimeline extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            pixiApp: null,
        };
        PIXI.settings.ROUND_PIXELS = true;
        this._pixiContainer = React.createRef();
        this.resizePIXIApp = this.resizePIXIApp.bind(this);
    }
    resizePIXIApp() {
        const parent = this.state.pixiApp.view.parentElement;
        this.state.pixiApp.renderer.resize(parent.clientWidth, parent.clientHeight);
        navigationView.currentElement.resize(parent.clientWidth, parent.clientHeight);
        this.state.pixiApp.render();
    }
    componentDidMount() {
        let app = new PIXI.Application();
        app.view.setAttribute("oncontextmenu", "return false;");
        app.view.addEventListener("mousedown", function (e) { e.preventDefault(); });
        app.renderer.backgroundColor = UIColors.bgColor;
        this._pixiContainer.current.appendChild(app.view);
        window.addEventListener("resize", this.resizePIXIApp);
        const parent = app.view.parentElement;
        app.renderer.resize(parent.clientWidth, parent.clientHeight);
        let timeline = new TimelineView(app.renderer.width, app.renderer.height, this.props.songManager);
        app.view.addEventListener("wheel", event => navigationView.passWheelEvent(event, app.renderer.view.getBoundingClientRect().left, app.renderer.view.getBoundingClientRect().top));
        navigationView.setStageRenderer(app.stage, app.renderer);
        navigationView.show(timeline);
        this.setState({ pixiApp: app }, this.resizePIXIApp);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resizePIXIApp);
        if (this.state.pixiApp != undefined) {
            this.state.pixiApp.destroy(true);
        }
    }
    render() {
        return React.createElement("div", { className: this.props.className },
            React.createElement("div", { id: "applicationContainer", ref: this._pixiContainer }));
    }
}
//# sourceMappingURL=SequencerApp.js.map